<template>
  <section class="hero has-background-black-darker" id="Projects">
    <div class="hero-body">

      <h1 class="title has-text-white">Projects</h1>

      <h3 class="subtitle has-text-weight-semibold">
        Fontys - Work - Hobby
      </h3>

      <div class="columns is-multiline">

        <!-- PROJECT GRID -->
        <div class="column is-12-mobile is-6-desktop projects">
          <div class="columns is-multiline is-mobile">

            <div
              class="column is-4-mobile is-4-tablet is-3-desktop"
              v-for="project in projectComponents"
              :key="project.name"
            >
              <div class="grid">
                <ImageCard
                  :imageSrc="getImagePath(project.image)"
                  :projectName="project.name"
                  @click="selectProject(project)"
                  @mouseenter="handleHover(project)"
                  @mouseleave="clearPreview"
                />
              </div>
            </div>

          </div>
        </div>

        <!-- PREVIEW -->
        <div class="column is-12-mobile is-6-desktop">

          <transition name="fade" mode="out-in">

            <!-- ACTIVE PROJECT -->
            <div
              v-if="activeProject"
              :key="activeProject.name"
              class="project-iframe-container"
            >
              <component :is="activeProject.component" />
            </div>

            <!-- DEFAULT -->
            <div v-else key="default" class="default-state">
              <p class="default-text select-project">
                Tap a project to view it
              </p>

              <img
                class="svg-img"
                src="../assets/selectAProject.svg"
                alt="Select project"
              />
            </div>

          </transition>

        </div>

      </div>
    </div>
  </section>
</template>


<script>
import ImageCard from './ImageCard.vue';
import PhilipsProject from './projects/PhilipsProject.vue';
import PhilipsInternshipProject from './projects/PhilipsInternshipProject.vue';
import OpenInnovationMinorProject from './projects/OpenInnovationMinorProject.vue';
import DexProject from './projects/DexProject.vue';
import Paaspop20Project from './projects/Paaspop20Project.vue';
import Glow20Project from './projects/Glow20Project.vue';
import GhgInternshipProject from './projects/GhgInternshipProject.vue';
import Kea19Project from './projects/Kea19Project.vue';
import FriendlyRobotProject from './projects/FriendlyRobotProject.vue';
import Junction19Project from './projects/Junction19Project.vue';
import Paaspop19Project from './projects/Paaspop19Project.vue';
import Glow19Project from './projects/Glow19Project.vue';
import SmartMirrorProject from './projects/SmartMirrorProject.vue';
import Hex18Project from './projects/Hex18Project.vue';
import SmartMobileProject from './projects/SmartMobileProject.vue';
import Glow18Project from './projects/Glow18Project.vue';
import MechHiveProject from './projects/MechHiveProject.vue';
import WeFactProject from './projects/WeFactProject.vue';

export default {
  name: 'ProjectsComponent',
  props: {
    msg: String
  },
  computed: {
  activeProject() {
    return this.hoveredProject || this.selectedProject;
  }
},
  components: {
    ImageCard,
    PhilipsProject,
    PhilipsInternshipProject,
    OpenInnovationMinorProject,
    DexProject,
    Paaspop20Project,
    Glow20Project,
    GhgInternshipProject,
    Kea19Project,
    FriendlyRobotProject,
    Junction19Project,
    Paaspop19Project,
    Glow19Project,
    SmartMirrorProject,
    Hex18Project,
    SmartMobileProject,
    Glow18Project,
    MechHiveProject,
    WeFactProject,
  },
  data() {
    return {
      projectComponents: [
        { name: 'WeFact Project', component: 'WeFactProject', image: 'wf.png', slug: 'wefact'},
        { name: 'MechHive Project', component: 'MechHiveProject', image: 'mechhive.jpg', slug: 'mechhive' },
        { name: 'Philips Project', component: 'PhilipsProject', image: 'philips.jpg', slug: 'philips' },
        { name: 'Philips Internship Project', component: 'PhilipsInternshipProject', image: 'philipsInternship.jpg', slug: 'philips-internship' },
        { name: 'Open Innovation Minor Project', component: 'OpenInnovationMinorProject', image: 'openInnovationMinor.jpg', slug: 'oi-minor' },
        { name: 'Dex Project', component: 'DexProject', image: 'DexProject.png', slug: 'dex' },
        { name: 'Paaspop 20 Project', component: 'Paaspop20Project', image: 'paaspop20.jpg', slug: 'paaspop20' },
        { name: 'Glow 20 Project', component: 'Glow20Project', image: 'glow20.jpg', slug: 'glow20' },
        { name: 'GHG Internship Project', component: 'GhgInternshipProject', image: 'ghgInternship.jpg', slug: 'ghg-internship' },
        { name: 'KEA 19 Project', component: 'Kea19Project', image: 'kea19.png', slug: 'kea19' },
        { name: 'Friendly Robot Project', component: 'FriendlyRobotProject', image: 'friendlyrobot.jpg', slug: 'friendlyrobot' },
        { name: 'Junction 19 Project', component: 'Junction19Project', image: 'junction19.jpg', slug: 'junction' },
        { name: 'Paaspop 19 Project', component: 'Paaspop19Project', image: 'paaspop19.jpg', slug: 'paaspop19' },
        { name: 'Glow 19 Project', component: 'Glow19Project', image: 'glow19.jpg', slug: 'glow19' },
        { name: 'Smart Mirror Project', component: 'SmartMirrorProject', image: 'smartmirror.jpg', slug: 'smartmirror' },
        { name: 'Hex 18 Project', component: 'Hex18Project', image: 'hex18.jpg', slug: 'hex' },
        { name: 'Smart Mobile Project', component: 'SmartMobileProject', image: 'smartMobile.jpg', slug: 'smartmobile' },
        { name: 'Glow 18 Project', component: 'Glow18Project', image: 'glow18.jpg', slug: 'glow18' },
      ],
      selectedProject: null,
      hoveredProject: null
    };
  },
  methods: {
  getImagePath(image) {
    return require(`../assets/portfolio/projects/${image}`);
  },

  selectProject(project) {
    this.selectedProject = project;
  },

  handleHover(project) {
    if (window.innerWidth > 768) {
      this.hoveredProject = project;
    }
  },

  clearPreview() {
    this.hoveredProject = null;
  }
}
};
</script>


<style scoped>
.rows {
  display: flex;
  flex-direction: column;
}

.subtitle {
  color: #7D4EFE;
  margin-bottom: 2rem;
}

.svg-img {
  width: 60%;
  max-width: 250px;
  display: block;
  margin: 2rem auto;
}

.grid {
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.grid::before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transition: opacity 0.3s;
}

/* Only enable hover overlay on desktop */
@media (hover: hover) {
  .grid:hover::before {
    opacity: 1;
  }
}

.project-iframe-container {
  height: auto;
  max-height: 120vh;
  overflow-y: auto;
  border-radius: 8px;
  margin-top: 1rem;
  padding: 1rem;
  background: #111;
}

.select-project {
  background-color: white;
  color: black;
  width: fit-content;
  max-width: 170vh;
  margin: 2rem auto;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
}

/* MOBILE OPTIMIZATION */
@media screen and (max-width: 768px) {
  .hero-body {
    padding: 1.5rem;
  }

  .project-iframe-container {
    max-height: none;
    padding: 0.5rem;
  }

  .columns {
    margin: 0;
  }
}
</style>